export function getProductTypesFromItems(
  items: { productTypes?: string[] }[]
): string[] {
  const productTypes = new Set<string>();
  items.forEach((item) =>
    (item.productTypes || []).forEach((productType) =>
      productTypes.add(productType)
    )
  );
  return Array.from(productTypes).sort();
}
